"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_final_form_1 = require("react-final-form");
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
function AdditionalInfoEDS({ handleSubmit }) {
    // Form Validation
    const formValidate = (values) => {
        if (values) {
            const errors = {};
            if (!values.paymentFrequency) {
                errors.paymentFrequency = 'Please select a payment frequency';
            }
            if (!values.annualIncome) {
                errors.annualIncome = 'Please enter annunal income';
            }
            if (!values.primaryIncomeSource) {
                errors.primaryIncomeSource = 'Please select a primary income source';
            }
            if (Object.keys(errors).length) {
                return errors;
            }
            else {
                return undefined;
            }
        }
    };
    // Form Submit
    const formSubmit = async (values) => {
        if (values) {
            //do something useful
            const isFormValid = formValidate(values);
            // Is form valid
            if (isFormValid === undefined) {
                // Form is valid
                if (handleSubmit) {
                    handleSubmit({
                        paymentFrequency: values.paymentFrequency,
                        annualIncome: (0, utils_1.parseAmount)(values.annualIncome),
                        primaryIncomeSource: values.primaryIncomeSource,
                    });
                }
                return undefined;
            }
            else {
                // Form IS NOT VALID
                return isFormValid;
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "max-width-800 mar-auto", children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, { onSubmit: formSubmit, render: ({ handleSubmit, submitting, hasValidationErrors }) => ((0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, className: "additional-info-form", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "Additional Info" }), (0, jsx_runtime_1.jsx)(components_1.H2, { variant: "headline-small", className: "mar-t-32", children: "We need to capture a few additional details to continue with your application." }), (0, jsx_runtime_1.jsx)("div", { className: "section-title pad-8 mar-t-32 mar-b-0", children: (0, jsx_runtime_1.jsx)(components_1.H3, { variant: "headline-small", className: "mar-b-0", children: "Income Details" }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("div", { className: "flex-col", children: [(0, jsx_runtime_1.jsx)(components_1.InputSelectNative, { name: "primaryIncomeSource", label: 'Primary Income Source', placeholder: "Select primary income source", options: config_1.OPTIONS_INCOME_SOURCE, required: true }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "annualIncome", component: components_1.InputNumber, options: config_1.OPTIONS_HOUSING, preicon: "$", allowLeadingZeros: false, thousandsGroupStyle: "thousand", thousandSeparator: ",", decimalScale: 2, placeholder: "Annual income", label: "Annual Income", fieldclass: "housing-payment-input", validate: utils_1.validateRequiredField }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(components_1.InputSelectNative, { name: "paymentFrequency", label: 'Payment Frequency', options: config_1.OPTIONS_PAY_FREQUENCY, placeholder: "Select payment frequency", required: true })] }), (0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", className: "button-warn mar-t-64", submitting: submitting, disabled: submitting || hasValidationErrors, children: "CONTINUE" })] })) }) }));
}
exports.default = AdditionalInfoEDS;
